module.exports = __webpack_public_path__ + "img/footer.97abfca7.png";